import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/promotions/_components/PromotionsPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/promotions/[[...presets]]/_components/PromotionsDetailsPage.tsx");
